export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "AI provider lub model nie został skonfigurowany": "AI provider or model has not been configured",
        "AI:": "AI:",
        "Anuluj": "Cancel",
        "Błąd parsowania strumienia": "Stream parsing error",
        "Błąd podczas tworzenia embedding": "Error while creating embedding",
        "Błąd serwisu AI:": "AI service error:",
        "Błąd:": "Error:",
        "Brak dostępnych konwersacji.": "No conversation available.",
        "Brak lub nieprawidłowy tekst": "Missing or invalid text",
        "Brak nazwy celu raportu PDF.": "Missing PDF report target name.",
        "Brak uprawnień": "Missing privileges",
        "Brak wiadomości": "No message",
        "Brak wymaganych danych celu raportu": "Missing required report target data",
        "Chat": "Chat",
        "Chat AI": "AI Chat",
        "Cześć, jestem Edito Bot. W czym mogę Ci pomóc?": "Hello, I am Edito Bot. How can I help you?",
        "Czy na pewno chcesz usunąć tę konwersację?": "Are you sure you want to delete this conversation?",
        "Czy na pewno chcesz usunąć tę wiadomość?": "Are you sure you want to delete this message?",
        "dni temu": "days ago",
        "Domyślny": "Default",
        "Dziękujemy za podzielenie się opinią": "Thank you for sharing feedback",
        "Edytuj i wyślij ponownie": "Edit and resend",
        "Edytuj wiadomość": "Edit message",
        "Generuj raport PDF (osoba)": "Generate PDF report (person)",
        "Generuj raport PDF (zespół)": "Generate PDF report (team)",
        "Generuję raport PDF...": "Generating PDF report...",
        "godz. temu": "hrs ago",
        "Imię i nazwisko": "First and Last Name",
        "Konfiguracja ai": "AI configuration",
        "Konwersacja": "Conversation",
        "Konwersacje z raportami": "Conversations with reports",
        "Kopiuj": "Copy",
        "Kto ukończył szkolenia": "Who completed training",
        "Lista osób z ukończonymi szkoleniami w zespole": "List of people with completed training in team",
        "min temu": "min ago",
        "Model do odpowiedzi": "Answer model",
        "Model embedding": "Embedding model",
        "Model embedding nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "Embedding model does not exist or is not active in your Azure OpenAI.",
        "Moje zespoły": "My teams",
        "Najniższy postęp w zespole": "Lowest progress in team",
        "Nazwa konwersacji": "Conversation name",
        "Nazwa zespołu": "Team name",
        "Nie można znaleźć odpowiedniego modelu embedding": "Cannot find suitable embedding model",
        "Nie można znaleźć odpowiedniego modelu text": "Cannot find suitable text model",
        "Nie otrzymano treści od asystenta.": "No content received from assistant.",
        "Nie pomocna": "Not helpful",
        "Nie udało się przetworzyć odpowiedzi AI dla raportu": "Failed to process AI answer for report",
        "Nie udało się wygenerować treści AI, raport zostanie utworzony bez nich.": "Failed to generate AI content, report will be created without it.",
        "Nie znaleziono użytkownika o podanym imieniu i nazwisku.": "No user found with provided first and last name.",
        "Nie znaleziono zespołów do wygenerowania raportu.": "No teams found to generate report.",
        "Nie znaleziono zespołu o podanej nazwie.": "No team found with provided name.",
        "Nie związana": "Not related",
        "Nieprawidłowe żądanie: Brak message w treści żądania.": "Invalid request: Missing message in request body.",
        "Nieprawidłowe żądanie: Brak sessionId w treści żądania.": "Invalid request: Missing sessionId in request body.",
        "Nieznany typ wykresu": "Unknown chart type",
        "Nowa": "New",
        "Nowa konwersacja": "New conversation",
        "Nowa konwersacja z raportami": "New conversation with reports",
        "Podaj nową nazwę...": "Enter new name...",
        "Podsumowanie postępów wszystkich moich zespołów": "Summary of progress of all my teams",
        "Podsumowanie szkoleń zespołu": "Summary of team training",
        "Podsumowanie użytkowników zespołu": "Summary of team users",
        "Podsumowanie zespołu": "Team summary",
        "Pokaż osoby z najniższym postępem": "Show people with lowest progress",
        "Pokaż zespoły, którymi zarządzam": "Show teams I manage",
        "Pomocna": "Helpful",
        "Porównaj moje zespoły i ułóż ranking": "Compare my teams and create ranking",
        "Postępy moich zespołów": "Progress of my teams",
        "Przejdź do konfiguracji, aby włączyć": "Go to configuration to enable",
        "Przygotuj podsumowanie szkoleń dla zespołu": "Prepare training summary for team",
        "Przygotuj raport o użytkowniku po imieniu i nazwisku": "Prepare user report by first and last name",
        "Ranking moich zespołów": "Ranking of my teams",
        "Raport PDF został pobrany.": "PDF report has been downloaded.",
        "Raport użytkownika": "User report",
        "Rozpocznij nową, klikając przycisk poniżej.": "Start a new one by clicking button below.",
        "System": "System",
        "Szczegółowy postęp i jednostki szkoleń": "Detailed progress and training units",
        "Szczegółowy raport użytkownika": "Detailed user report",
        "Średni postęp i liczba ukończonych szkoleń per osoba": "Average progress and number of completed training sessions per person",
        "Ta odpowiedź jest pomocna": "This answer is helpful",
        "Ta odpowiedź jest powiązana": "This answer is related",
        "Ta odpowiedź nie jest pomocna": "This answer is not helpful",
        "teraz": "now",
        "Ty:": "You:",
        "Unikalne szkolenia zespołu z realizacją i średnim postępem": "Unique team training sessions with completion and average progress",
        "Ustawienia modeli": "Model settings",
        "Ustawienia modeli AI": "AI model settings",
        "Usuń": "delete",
        "Usuń konwersację": "Delete conversation",
        "Użytkownik": "User",
        "wczoraj": "yesterday",
        "Wpisz wiadomość...": "Type a message...",
        "Wprowadź treść wiadomości...": "Enter message content...",
        "Wybierz konwersację, aby rozpocząć": "Select conversation to start",
        "Wybierz lub utwórz konwersację": "Select or create conversation",
        "Wybierz model do czatu": "Select chat model",
        "Wybierz model embedding": "Select embedding model",
        "Wybróbuj możliwości chatu AI": "Try AI chat capabilities",
        "Wygeneruj raport PDF dla wskazanego zespołu": "Generate PDF report for indicated team",
        "Wygeneruj raport PDF dla wskazanej osoby": "Generate PDF report for indicated person",
        "Wygeneruj wykres postępów zespołu": "Generate team progress chart",
        "Wykres postępów zespołu": "Team progress chart",
        "Wystąpił błąd serwera podczas streamingu. Spróbuj ponownie później.": "A server error occurred during streaming. Please try again later.",
        "Wystąpił nieoczekiwany błąd.": "An unexpected error occurred.",
        "Wystąpił problem z pobraniem wiadomości.": "A problem occurred while retrieving messages.",
        "Wyślij": "Send",
        "Wyślij ponownie": "Resend",
        "Wyślij wiadomość": "Send message",
        "Zadaj pytanie": "Ask a question",
        "Zapisz": "Save",
        "Zapisz i wyślij ponownie": "Save and resend",
        "Zmień nazwę": "Rename",
        "Zmień nazwę konwersacji": "Rename conversation"
    }
};
